import { memo, useMemo, useState } from "react";
import SearchBox from "../../components/SearchBox";
import useWorkCenter from "../../hooks/useWorkCenter";

import DataGrid, { RowsChangeData, SortColumn } from 'react-data-grid'
import { WorkCenterColumns } from "../../constants/Column";
import { WorkCenter } from "../../components/types";
import { DataStore } from "aws-amplify";
import { DgtPdWorkCenter } from "../../models";

type Comparator = (a: WorkCenter, b: WorkCenter) => number;
const getComparator= (sortColumn: string): Comparator => {
  switch (sortColumn) {
    case 'id':
    case 'description':
      return (a, b) => {
        return a[sortColumn].localeCompare(b[sortColumn]);
      };
    case 'machineCategory':
      return (a, b) => {
        return (a[sortColumn] || '').localeCompare(b[sortColumn]!);
      };
    case 'active':
      return (a, b) => {
        return a[sortColumn] === b[sortColumn] ? 0 : a[sortColumn] ? 1 : -1;
      };
    default:
      throw new Error(`unsupported sortColumn: "${sortColumn}"`);
  }
}

export default memo(function MachineMaster() {
  const [ keyword, setKeyword ] = useState<string>('')
  const [ refresh, setRefresh ] = useState<boolean>(false)
  const [ sortColumns, setSortColumns ] = useState<readonly SortColumn[]>([]);

  const machines = useWorkCenter(keyword, refresh)

  const onEditWorkCenter = async (rows: WorkCenter[], changedInfo: RowsChangeData<WorkCenter>) => {
    const changedRowIdx = changedInfo.indexes[0]
    const changedRow = rows[changedRowIdx]
    const existWorkCenter = await DataStore.query(DgtPdWorkCenter, changedRow.id)
    if (existWorkCenter) {
      if (changedInfo.column.key === 'machineCategory') { // update machine category
        const updating = DgtPdWorkCenter.copyOf(existWorkCenter, updated => {
          updated.machineCategory = changedRow.machineCategory
        })
        await DataStore.save(updating)
      } else if (changedInfo.column.key === 'active') { // update active/inactive
        const updating = DgtPdWorkCenter.copyOf(existWorkCenter, updated => {
          updated.active = changedRow.active
        })
        await DataStore.save(updating)
      }
      setRefresh(!refresh)
    }
  }

  const sortedRows = useMemo((): readonly WorkCenter[] => {
    if (sortColumns.length === 0) return machines;

    return [...machines].sort((a, b) => {
      for (const sort of sortColumns) {
        const comparator = getComparator(sort.columnKey);
        const compResult = comparator(a, b);
        if (compResult !== 0) {
          return sort.direction === 'ASC' ? compResult : -compResult;
        }
      }
      return 0;
    });
  }, [ machines, sortColumns ]);

  return <div className="container px-3">
    <div className="flex items-center justify-between mb-6">
      <div className="flex flex-col ">
        <h4 className='font-bold '>Machine Master</h4>
        <small className='text-gray-500'>รายการเครื่องจักร</small>
      </div>
    </div>
    <div className="flex gap-4 mb-6">
      <SearchBox
        className="flex-1 "
        placeholder='ค้นหาด้วย Machine No'
        value={keyword}
        onChanged={setKeyword}
      />
    </div>
    <DataGrid
      style={{ height: "100%", contain: "none" }}
      columns={WorkCenterColumns}
      rows={sortedRows}
      onRowsChange={onEditWorkCenter}
      defaultColumnOptions={{
        sortable: true,
        resizable: true
      }}
      sortColumns={sortColumns}
      onSortColumnsChange={setSortColumns}
    />
  </div>
});